import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormField from '../FormField';
import municipios from '../../../data/municipios.json';

export default function IdentificacaoMunicipio() {
  const { setValue, watch, control } = useFormContext();

  // Observa mudanças no nome do município
  React.useEffect(() => {
    const nomeMunicipio = watch('nome_municipio');
    const municipio = municipios.find(m => m.municipio === nomeMunicipio);
    if (municipio) {
      setValue('codigo_ibge', municipio.codigo_ibge);
    } else if (nomeMunicipio === '') {
      setValue('codigo_ibge', '');
    }
  }, [watch('nome_municipio')]);

  return (
    <div>
      <div className="mb-6 p-4 bg-blue-50 rounded-lg">
        <p className="text-sm text-blue-700">Esta seção coleta informações básicas sobre o município ou localidade. Preencha com os dados mais atualizados disponíveis.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          name="nome_municipio"
          label="Nome do município/localidade"
          type="select"
          options={municipios.map(m => ({ value: m.municipio, label: m.municipio }))}
          className="[&_.input]:bg-gray-50"
          required
          helpText="Selecione o município da lista"
        />
        
        <FormField
          name="codigo_ibge"
          label="Código do Município (IBGE)"
          type="number"
          placeholder="Código será preenchido automaticamente"
          disabled
          className="cursor-not-allowed"
          helpText="Código de 7 dígitos do IBGE (preenchido automaticamente)"
        />
      </div>
      
      <hr className="border-t border-gray-300 my-6" />
      <div className="mt-6 space-y-4">
        <FormField
          name="fontes_principais_secao1"
          label="Fontes principais"
          type="textarea"
          placeholder="Liste as principais fontes utilizadas nesta seção do formulário"
          helpText=""
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
        
        <FormField
          name="links_acesso_secao1"
          label="Links de acesso"
          type="textarea"
          placeholder="Insira os links para acesso às fontes"
          helpText="Informe URLs para acesso às fontes quando disponível"
          rows={3}
          className="[&_.input]:min-h-[5rem]"
        />
      </div>
    </div>
  );
}
